<script>
import { mapState, mapActions } from 'vuex'
import * as def from '@/lib/definition'
import { datestr, getSize } from '@/lib/common'
import csImage from '@/components/cs-image.vue'

export default {
  components: {
    csImage
  },
  props: [
    'pageId'
  ],
  setup () {
    return {
      def
    }
  },
  computed: {
    ...mapState([
      'pages'
    ]),
    page () {
      return this.pages[this.pageId] || { images: [] }
    },
    images () {
      const images = [...this.page.images]
      images.forEach(image => {
        def.dateObjectItems.forEach(key => {
          if (image[key] && typeof image[key] === 'object') {
            image.sort = image[key].getTime()
            image[key] = datestr(image[key], datestr.dateTime)
          }
        })
      })
      images.sort((a, b) => b.sort - a.sort)
      return images
    }
  },
  watch: {
    pageId: {
      immediate: true,
      handler () {
        this.fetchImages(this.pageId)
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchImages',
      'deleteImage'
    ]),
    deleteImg (id) {
      if (confirm('画像を削除します。よろしいいですか？')) {
        this.deleteImage({ pageId: this.pageId, id })
          .then(() => console.log('Deleted image'))
      }
    },
    getFileName (image) {
      const fileName = image.metadata && image.metadata.customMetadata
        ? image.metadata.customMetadata.fileName
        : ''
      return fileName
    },
    getSize (image) {
      const size = image.metadata ? image.metadata.size : 0
      return getSize(size)
    }
  }
}
</script>

<template>
  <div class="image-list level is-mobile">
    <section>
      <h1 class="is-size-3">画像の管理</h1>
      <ul>
        <li
          v-for="image in images"
          :key="image.id"
          class="level-left"
        >
          <cs-image
            :fullPath="image.full_path"
            @getMetadata="image.metadata = $event"
            class="cs-image has-text-align-center"
          />
          <div class="content level">
            <dl class="dl-row">
              <dt>ローカルファイル名</dt>
              <dd>{{ getFileName(image) }}</dd>
              <dt>{{ def.itemNames['file_size'] }}</dt>
              <dd>{{ getSize(image) }}</dd>
              <dt>{{ def.itemNames['created'] }}</dt>
              <dd>{{ image.created }}</dd>
              <dt>{{ def.itemNames['created_by'] }}</dt>
              <dd>{{ image.created_by }}</dd>
            </dl>
            <button
              @click="deleteImg(image.id)"
              class="button"
            >
              <i class="material-icons">delete</i>
              <span>画像を削除</span>
            </button>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@use "../styles/variables";
.image-list {
  border-left: 2px solid variables.$gray-light;
  background-color: variables.$gray-lighter;
  align-items: flex-start;
  width: 100%;
  max-height: 100%;
  overflow: scroll;
  padding: 1rem;
  section {
    width: 100%;
  }
  ul {
    li {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      padding: 1rem;
      border-bottom: solid 1px grey;
      .cs-image {
        min-width: 12rem;
        width: 12rem;
        max-height: 12rem;
      }
      .content {
        align-items: flex-end;
        width: calc(100% - 10rem);
      }
    }
  }
}
</style>
<style lang="scss">
.image-list {
  .cs-image {
    img {
      max-width: 12rem;
      max-height: 12rem;
    }
  }
}
</style>
